import { type FC, type PropsWithChildren, createContext, useMemo } from 'react';

import { useQuery } from '@betterment/js-runtime';

import { urlBuilder } from '../../Shared/urlBuilder';
import { NoticeItem } from '../data';

type NoticesContextValue = {
  notice: NoticeItem | null;
  hasLoaded: boolean;
  fetchNotice: () => Promise<unknown>;
};

export const NoticesContext = createContext<NoticesContextValue>({
  notice: null,
  hasLoaded: false,
  fetchNotice: () => Promise.resolve(),
});

export const NoticesProvider: FC<PropsWithChildren> = ({ children }) => {
  const { data, refetch } = useQuery<NoticeItem[]>(urlBuilder.apiV2GlobalNotices(), {
    qs: { count: 1 },
    skip: true,
  });

  const value = useMemo(
    (): NoticesContextValue => ({
      notice: data?.[0] ?? null,
      hasLoaded: data !== null,
      fetchNotice: refetch,
    }),
    [data, refetch]
  );

  return <NoticesContext.Provider value={value}>{children}</NoticesContext.Provider>;
};
